import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService, CompanyService, Toaster } from '@app/services';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResetPasswordFields } from '@app/models';
import { switchMap } from 'rxjs/operators';
import { LocalStorage } from 'ngx-webstorage';
import { environment } from '@env/environment';

@Component({
  selector: 'ngx-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../../layout/auth.style.scss'],
})
export class ResetPasswordComponent implements OnInit {
  @LocalStorage() token: string;
  @LocalStorage() organizationId: string;
  @LocalStorage() companyType: string;
  @LocalStorage() role: string;
  @LocalStorage() refresh: string;

  isRCDSS: boolean = environment?.name === 'rcdss';

  passwordForm = new FormGroup({
    password1: new FormControl('', [Validators.required]),
    password2: new FormControl('', [Validators.required]),
  });
  resetPwdObj: ResetPasswordFields = new ResetPasswordFields();
  loginObj: any = {};
  submitted: boolean = false;
  tokenUser: string;
  email: string;

  isFirst: boolean;
  returnUrl: string;

  constructor(
    private $account: AccountService,
    private $company: CompanyService,
    private $toaster: Toaster,
    protected router: Router,
    protected route: ActivatedRoute,
  ) {
    if (!this.isRCDSS) {
      this.tokenUser = this.route.snapshot.params.token;
      this.email = this.route.snapshot.params.email;
    } else {
      console.log(this.router.url.toString());
      this.tokenUser = this.route.snapshot.queryParams.token || this.route.snapshot.params.token;
      this.email = this.route.snapshot.queryParams.email || this.route.snapshot.params.email;
    }
  }

  get password1() {
    return this.passwordForm.get('password1');
  }

  get password2() {
    return this.passwordForm.get('password2');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['return'] || '/dashboard';
      this.isFirst = params['isFirst'] === 'true';
      if (this.isRCDSS) {
        this.tokenUser = params['t'];
        this.email = params['u'];
        console.log(this.tokenUser);
        console.log(this.email);
      }
      if (this.isFirst === true) {
        this.returnUrl += this.returnUrl.indexOf('?') != -1 ? '&' : '?';
        this.returnUrl += 'isFirst=true';
      }
    });
  }

  updatePassword() {
    this.submitted = true;

    this.resetPwdObj.password = this.password1.value;
    this.resetPwdObj.password2 = this.password2.value;
    this.resetPwdObj.token = this.tokenUser;

    this.$account
      .updatePassword(this.resetPwdObj)
      .pipe(
        switchMap(_ => {
          this.loginObj.email = this.email;
          this.loginObj.username = this.email;
          this.loginObj.password = this.password1.value;
          return this.$account.login(this.loginObj);
        }),
        switchMap(res => {
          const refresh: string = String(res.headers.get('Refresh'));
          const token: string = String(res.headers.getAll('Authorization'));
          this.token = token;
          this.refresh = refresh;
          return this.$account.getProfile();
        }),
        switchMap(res => {
          this.role = res.role;
          this.organizationId = res.organization_id;
          return this.$company.getById(this.organizationId);
        }),
      )
      .subscribe(
        company => {
          this.companyType = company.login_as;
          this.router.navigateByUrl(this.returnUrl);
          console.log(this.returnUrl);
        },
        error => {
          console.error(error);
          const errorMsg = !!error.error ? error.error.detail : 'Something went wrong, please try again later';
          this.$toaster.show('error', null, errorMsg);
          this.submitted = false;
        },
      );
  }
}
